import classNames from "classnames";

function FormSubmitButton({ onClick, className }) {
  return (
    <button
      className={classNames(
        "h-10 w-max flex flex-row items-center cursor-pointer rounded-sm form-submit-button-background",
        className
      )}
      onClick={onClick}
    >
      <span className="w-full h-full flex flex-row items-center px-3 select-none font-extrabold">
        Submit
      </span>
    </button>
  );
}

export default FormSubmitButton;
